import { inject } from '@angular/core';
import { Router, type ResolveFn } from '@angular/router';
import { PropertyService } from '@core/services/property.service';
import { Property } from '@shared/models';
import { of, tap } from 'rxjs';

export const propertiesResolver: ResolveFn<Property[]> = (route, state) => {
  const propertyService = inject(PropertyService);
  const router = inject(Router);

  if (propertyService.properties().length > 0) {
    return of(propertyService.properties());
  }

  return propertyService.getProperties().pipe(
    tap(() => {
      const urlTree = router.parseUrl(state.url);
      const segments = urlTree.root.children['primary']?.segments;

      if (segments) {
        const propertyIndex = segments.findIndex(s => s.path === 'property');
        if (propertyIndex !== -1 && segments[propertyIndex + 1]) {
          const propertyId = Number(segments[propertyIndex + 1].path);
          const found = propertyService.properties().find(p => p.placeId === propertyId);
          if (found) {
            propertyService.selectProperty(found);
          }
        }
      }
    })
  );
};